// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"candidate-editor_wrapper__6qgRW","description":"candidate-editor_description__2KjlO","titleInput":"candidate-editor_titleInput__2XVO2"};